<template>
  <div>
    <h2>Orphaned {{ transaction.transactionType }} Transaction</h2>
    <p class="lead">&quot;{{ transaction.transactionMemo }}&quot;</p>
    <p>
      {{ date }}
      <strong><money-block :dollar="transaction.amount.value" /></strong>
    </p>
    <p>Buyer: {{ transaction.buyer?.username }}</p>
    <p>This transaction does not have an order associated with it.  Do you want to select an order for this transaction?</p>

    <div class="row">
      <span v-for="o in orders" :key="o.id" class="col-4 position-relative mb-3">
        <order-card :order="o" />
        <div role="button" class="position-absolute w-100 h-100" style="top:0;left:0;" @click.stop.prevent="selectOrder(o)"></div>
      </span>
    </div>

  </div>
</template>
<script setup>
import {defineProps, computed, ref, defineEmits} from 'vue';
import {useStore} from 'vuex'
import MoneyBlock from "@/app/components/Utils/MoneyBlock.vue";
import OrderCard from "@/app/components/orders/OrderCard.vue";
const store = useStore()
const props = defineProps({
  transaction: Object,
})

const emits = defineEmits(["onSelectOrder"])
const orders = ref([])

const date = computed(() => {
  const d = new Date(props.transaction.transactionDate);
  return d.toLocaleDateString();
})

function selectOrder(o) {
    emits('onSelectOrder', o);
}


  store.dispatch("eshop/getRecentOrders", {days: 7}) // week
      .then(ords => orders.value = ords.filter(o => o.order_status==='Completed'))
      .catch(error => console.log(error))



</script>
